import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 mt-24 pb-28 md:pb-12">
      <div className="divider-yellow" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 pt-16 grid md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img
              src="https://customer-assets.emergentagent.com/job_taste-egg-street/artifacts/va7h5bvn_image.png"
              alt="Taste of Egg"
              className="h-14 w-auto rounded-md"
            />
            <div className="leading-none">
              <span className="text-white tracking-[0.22em] text-[11px] font-bold block">CLAYTON SOUTH · VIC</span>
              <span className="text-yellow-brand font-script text-xl block leading-none mt-1">The Protein House</span>
            </div>
          </div>
          <p className="text-white/60 mt-5 max-w-md leading-relaxed">
            India's favourite egg flavours, served fresh from our food truck in Clayton, Melbourne.
            30+ flavour-packed Indian street-food dishes.
          </p>
          <a
            href="https://instagram.com/tasteofegg_australia"
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="inline-flex items-center gap-2 mt-6 text-white/80 hover:text-yellow-brand transition-colors"
          >
            <Instagram className="w-5 h-5" />
            <span className="font-semibold">@tasteofegg_australia</span>
          </a>
        </div>

        <div>
          <h4 className="text-yellow-brand uppercase text-xs tracking-[0.22em] font-bold mb-4">Explore</h4>
          <ul className="space-y-2 text-white/70">
            <li><Link to="/menu" className="hover:text-yellow-brand">Menu</Link></li>
            <li><Link to="/best-sellers" className="hover:text-yellow-brand">Best Sellers</Link></li>
            <li><Link to="/gallery" className="hover:text-yellow-brand">Gallery</Link></li>
            <li><Link to="/about" className="hover:text-yellow-brand">Our Story</Link></li>
            <li><Link to="/faq" className="hover:text-yellow-brand">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-yellow-brand">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-yellow-brand uppercase text-xs tracking-[0.22em] font-bold mb-4">Reach Us</h4>
          <ul className="space-y-3 text-white/70">
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 mt-1 text-yellow-brand" />
              <a href="tel:0434508712" className="hover:text-yellow-brand">0434 508 712</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="w-4 h-4 mt-1 text-yellow-brand" />
              <a href="mailto:info@tasteofegg.com.au" className="hover:text-yellow-brand">info@tasteofegg.com.au</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 mt-1 text-yellow-brand" />
              <span>Khau gali<br />Clayton South, VIC 3169<br />Melbourne, Australia</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12 pt-6 border-t border-white/5 grid grid-cols-1 md:grid-cols-3 items-center gap-3 text-sm text-white/40">
        <span className="md:justify-self-start text-center md:text-left">
          © {new Date().getFullYear()} Taste of Egg. All rights reserved.
        </span>
        <div className="flex justify-center gap-5">
          <Link to="/privacy" className="hover:text-yellow-brand">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-yellow-brand">Terms & Conditions</Link>
        </div>
        <span className="md:justify-self-end text-center md:text-right">
          Designed by{" "}
          <a
            href="https://digitaltable.com.au"
            target="_blank"
            rel="noreferrer"
            className="text-yellow-brand font-semibold hover:underline"
            data-testid="footer-designer"
          >
            digitaltable.com.au
          </a>
        </span>
      </div>
    </footer>
  );
}
